import script from "./FiltroOpciones.vue?vue&type=script&setup=true&lang=js"
export * from "./FiltroOpciones.vue?vue&type=script&setup=true&lang=js"

import "./FiltroOpciones.vue?vue&type=style&index=0&id=2b31631e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b31631e"]])

export default __exports__